import React, { useEffect, useState } from 'react';
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import TeamMultiSelect from '@shared/ui/organisms/team-drop-down-list/TeamMultiSelect';
import { UserSearchDropDownList } from '@shared/ui/molecules/UserSearchDropDownList';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { TeamEntity } from '@shared/models/team.models';
import { BasicUserInfo } from '@shared/models/user.models';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectAllTeams } from "@shared/store/config.duck";
import { failureNotification } from "@shared/store/notification.duck";
import { moveUser, selectIsLoading, selectSelectedTeam, setSelectedTeam } from "../ducks/add-users.duck";
import { selectCurrentUser } from "@shared/store/auth.duck";
import { isTeamAdminUser } from '@shared/utils/AccessControl';
import Colours from '@shared/ui/atoms/Colours';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function AddExistingUserForm(props: Props) {
  const dispatch = useDispatch();
  const teams = useSelector(selectAllTeams);
  const loading = useSelector(selectIsLoading);
  const selectedTeam = useSelector(selectSelectedTeam);
  const currentUser = useSelector(selectCurrentUser);
  const [user, setUser] = useState<BasicUserInfo | undefined>();
  const {t} = useTranslation();

  const isTeamAdmin = isTeamAdminUser(currentUser);
  const currentUsersTeam = currentUser?.teamEntity;

  useEffect(() => {
    if (currentUsersTeam && isTeamAdmin) {
      dispatch(setSelectedTeam(currentUsersTeam));
    }
  }, [dispatch, isTeamAdmin, currentUsersTeam]);

  const onTeamSelect = (teams: TeamEntity[]) => {
    if (teams.length > 0) {
      const team = teams.find(t => t === teams[0]);
      dispatch(setSelectedTeam(team));
    }
  }

  const onUserSelect = (user: BasicUserInfo) => {
    setUser(user);
  }

  const onMoveTeamMemberClicked = () => {
    if (user && selectedTeam) {
      dispatch(moveUser({user, team: selectedTeam}))
    } else {
      dispatch(failureNotification('Select a team and a user'))
    }
  }

  return (
    <>
      <Column style={{marginBottom: 32}}>
        <BodySmall className="textField__label" weight={600}>{t('search-for-existing-user')}</BodySmall>
        <UserSearchDropDownList closeOnSelect={true}
                                disabled={loading}
                                onSelect={onUserSelect} />
      </Column>

      <Column style={{marginBottom: 72}}>
        <BodySmall className="textField__label" weight={600}>{t('select-team-to-add-user-to')}</BodySmall>
        <TeamMultiSelect onSelect={onTeamSelect}
                         teams={teams}
                         disabled={loading}
                         singleSelect={true}
                         selectedTeams={selectedTeam ? [selectedTeam] : []} />
        {isTeamAdmin && <BodySmall style={{marginTop: 8}} colour={Colours.darkGrey} weight={400}>{t('team-admins-limitation')}</BodySmall>}

      </Column>

      <PrimaryButton fullWidth={true}
                     size={ButtonSize.Large}
                     dataTest="moveTeamMember"
                     disabled={loading}
                     buttonType="submit"
                     style={{marginTop: 'auto'}}
                     text="button.add-to-team"
                     click={onMoveTeamMemberClicked}/>
    </>
  )
}

interface Props {
}
